<template>
  <QItem v-close-popup>
    <QItemSection @click="$emit('view')" class="cursor-pointer">
      <div class="row items-center">
        <QIcon name="eva-person-outline" size="21px" class="q-mr-sm" />
        <span>View Profile</span>
      </div>
    </QItemSection>
  </QItem>
</template>

<script>
import { QItem, QItemSection, QIcon, ClosePopup } from 'quasar';

export default {
  name: 'UserProfileMenuView',
  components: {
    QItem,
    QItemSection,
    QIcon
  },
  directives: {
    ClosePopup
  }
};
</script>
